import { useGenericMutation } from '@hooks/use-generic-mutation';
import { request } from '@utils/request/request';
import { RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';
import { ImportArguments, ImportFormData, ImportResponse } from './type';

const importCsv = async (importCsvData: ImportFormData) => {
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/nightgraph/import-csv`;
  return request({ url, method: RequestMethod.POST, body: importCsvData });
};
export const useImportCsv = () => {
  return useGenericMutation(
    [QUERY_KEYS.importCsv],
    async ({ importData }: ImportArguments): ImportResponse => importCsv(importData)
  );
};
